module.exports = __webpack_public_path__ + "img/two_1.de594d90.png";